import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from "@angular/core";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
} from "src/app/shared/service";
import {
    DtgActionType
} from "src/app/shared/vo";

@Component({
    selector: "[company-selector-tree-node]"
    ,templateUrl: "./company.selector.tree.node.component.html"
    ,providers: []
})
export class CompanySelectorTreeNodeComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() companyInfo:any;
    @Output() callbackIsOpen = new EventEmitter();
    isSelected:boolean = false;
    isFound:boolean = false;
    searchValue:string;
    isShown:boolean = true;
    DtgActionType = DtgActionType;

    constructor(
        private fvmsCommonService:FvmsCommonService
    ) {
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo){
                    if(companyInfo.companyId === this.companyInfo.companyId){
                        this.isSelected = true;
                        if(this.companyInfo.children.length){
                            this.companyInfo.isOpen = true;
                        }
                    }else{
                        this.isSelected = false;
                    }
                }
            });
        this.fvmsCommonService.subscribeSearchKeyword()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(searchValue => {
                this.searchValue = searchValue;
                this.isFound = false;
                this.isShown = true;
                this.checkSearchValue();
            });
    }

    ngOnInit() {
        // console.log("DtgServiceCompanyTreeNodeComponent",this.companyInfo);
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {

    }

    clickToggleOpenChild(){
        if(this.companyInfo && this.companyInfo.children && this.companyInfo.children.length){
            this.companyInfo.isOpen = !this.companyInfo.isOpen;
        }
    }

    clickItem(){
        this.isSelected = true;
        this.fvmsCommonService.setCompanyInfo(this.companyInfo);
    }

    checkSearchValue(){
        if(this.searchValue){
            if(this.companyInfo.companyNm.indexOf(this.searchValue) > -1){
                this.isFound = true;
                this.callbackIsOpenFromChild(this.companyInfo.companyId);
            }else{
                this.isShown = false;
            }
        }
    }

    callbackIsOpenFromChild(companyId:string){
        // console.log("callbackClickActionFromChild",companyId);
        if(companyId){
            if(this.companyInfo.companyId === companyId){
                this.companyInfo.isOpen = true;
                this.callbackIsOpen.emit(this.companyInfo.pCompanyId);
            }
        }
    }
}